export default __webpack_public_path__ + "static/media/coin_glare.e2965e75.png";